import {ref, reactive, toRefs, onMounted, defineComponent, getCurrentInstance, computed} from 'vue';
export default defineComponent({
    name: "LoginLogList",
    setup(){
        const {proxy}=getCurrentInstance() as any;
        const utils=proxy.utils;
        let dataObj=reactive({
            pageListRef:null,
            pageList: {
                showRadio:false,
                isShowFixCol:false,
                queryParam: {},
                modelMethod: utils.Api.buildUrl("/loginLog/pageData")
            }
        })
        return{
            ...toRefs(dataObj)
        }
    }
});